/** 一般ユーザーで選択可能なトラッキング期間の最大月数 */
export const TRACKING_RANGE_MONTHS = 2;

/** 管理者モードで選択可能なトラッキング期間の最大月数 */
export const ADMIN_TRACKING_RANGE_MONTHS = 6;

/**
 * 終了日候補が開始日基準の許容範囲外かどうか（開始日未満・最大期間超過）
 */
export const isOutsideTrackingRangeEnd = (startDate, time, rangeMonths = TRACKING_RANGE_MONTHS) => {
  const start = new Date(startDate);
  start.setHours(0, 0, 0, 0);
  const maxEnd = new Date(start);
  maxEnd.setMonth(maxEnd.getMonth() + rangeMonths);
  const candidate = new Date(time);
  candidate.setHours(0, 0, 0, 0);
  return candidate.getTime() < start.getTime() || candidate.getTime() > maxEnd.getTime();
};

/**
 * 管理者モードの過去期間選択時、開始日から見て終了日候補が許容範囲外かどうか
 */
export const isOutsideAdminPastTrackingRange = (startDate, time) => {
  return isOutsideTrackingRangeEnd(startDate, time, ADMIN_TRACKING_RANGE_MONTHS);
};
